export const CUSTOMER_ALREADY_EXISTS_PARAM = "CUSTOMER_ALREADY_EXISTS";
export const CUSTOMER_ALREADY_VALIDATED_PARAM = "CUSTOMER_ALREADY_VALIDATED";
